// extracted by mini-css-extract-plugin
export default {"content":"LoginRequiredModal_content__nH2Kl","dialogText":"LoginRequiredModal_dialogText__4BBmY"};